import React, { useEffect, useState } from "react";
import { Modal, Icon, Button, Select } from "antd";
import { Http } from "../../../../../../helpers/axois";
import style from "../../../../Assisted/forms/list.module.sass";
import publicIcon from "../../../../../../assets/svg/solo/public_col_ico.svg"
import privateIcon from "../../../../../../assets/svg/solo/private_col_ico.svg"
import { useSelector } from "react-redux";
import _ from "lodash";
import { useToast } from "../../../../../../helpers/commonFunction";
import { AppState } from "../../../../../../stateManager/store";
const { Option } = Select

interface SoloFlowModal {/*eslint-disable*/
    visible: boolean;
    getForms?: () => void;
    setvisible: (status: boolean) => void;
    setSelectedSoloFlowResp?: (vaL: any) => void;
    appId: any;
    branchId?: any;
    editable?: boolean;
    selectedAppname?: string;
    branch?: string;
    version?: any;
    soloFlowResp?: any;
    soloSelectedNodeId?: string;
    appVersion: { currentVersion: boolean; versionId: string, appId: string };
    getSoloFlows: (Saveform: any, app?: any, select?: string, appName?: string, branch?: string, version?: string) => void;
    selectedSolo?: string;
}
export const SoloModal: React.FC<SoloFlowModal> = ({
    visible,
    setvisible,
    appId,
    branchId,
    appVersion,
    selectedAppname,
    soloFlowResp,
    getSoloFlows,
    selectedSolo,
    setSelectedSoloFlowResp
}) => {
    const [soloFlow, setSoloFlow]: any = useState(null);
    const [appList, setAppList]: any = useState(null);
    const [appName, setAppName]: any = useState(null);
    const [branches, setBranches]: any = useState(null)
    const [selectedSoloFlow, setSelectedSoloFlow]: any = useState(selectedSolo || "");
    const [findAppName, setFindAppname]: any = useState(selectedAppname || null);
    const [appNameNotinList, setAppNotinList]: any = useState("")
    const [soloFlowName, setSoloFlowName]: any = useState("")
    const orgId: string = useSelector((state: any) => {
        return state.org.selectedOrg.id
    })
    const { ErrorToast } = useToast()
    const orgPermissions: any = useSelector((state: any) => {
        return state.org.orgPermissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
    const { selectedOrg } = useSelector((state: AppState) => state.org)
    const loggedInUserId = useSelector((state: any) => {
        return state.user.data.user.id
    })
    useEffect(() => {
        getApps()
    }, [appId, appVersion, selectedSolo, branchId]);

    useEffect(() => {
        if (appName || soloFlowResp?.id) {
            appList && appList.forEach((e: any) => {
                if (e.appId === appName || e.appId === soloFlowResp?.id) {
                    setSelectedSoloFlow("");
                    setSoloFlowName("");
                    setFindAppname(e.appName)
                    getBranches()
                } else if (e.appId !== soloFlowResp?.id) {
                    const findResp = appList.filter((e: any) => { return e.appId === soloFlowResp?.id })
                    if (findResp.length === 0) {
                        setAppNotinList(soloFlowResp?.id)
                    }
                }
            })
        }
    }, [appName])

    const soloFlows = (data: any) => {
        Http.get(`/apps/${appName ? appName : soloFlowResp?.id ? soloFlowResp?.id : ""}/solo-flows?versionId=${data.version_id}`).subscribe((formRes: any) => {
            setSoloFlow(formRes.flows?.filter((el: any) => {
                return el.type === "private"
            }))
            formRes?.flows.forEach((res: any) => {
                if (res.name === soloFlowResp?.name) {
                    setSelectedSoloFlow(res.name)
                } else if (soloFlowResp?.name !== res.name) {
                    setSoloFlowName(soloFlowResp?.name)
                }
            })
            if (formRes?.flows?.length <= 0) {
                setSelectedSoloFlow("");
                setSoloFlowName("")
            }
        })
    }

    const getApps = () => {
        Http.get(`org/${orgId}/apps`).subscribe((resp: any) => {
            const appListDetails = resp.map((item: any) => {
                if (item.type === "a8solo") {
                    return {
                        appName: item.name,
                        appId: item.appId,
                    }
                }
            }).filter((e: any) => { return e })
            setAppList(appListDetails)
            if (!appName) {
                appListDetails && appListDetails.forEach((e: any) => {
                    if (e.appName === selectedAppname || e.appId === soloFlowResp?.id) {
                        getBranches()
                        setAppName(e.appId)
                    } else {
                        const findResp = appListDetails.filter((e: any) => { return e.appId === soloFlowResp?.id })
                        if (findResp.length === 0) {
                            setAppNotinList(soloFlowResp?.id)
                            setSoloFlowName(soloFlowResp?.name)
                        }
                    }
                })
            }
        })
    }

    const getBranches = () => {
        if((!orgPermissions.includes('branch.View') || !orgPermissions.includes('app.View')) &&  loggedInUserId!=selectedOrg?.owner){
            ErrorToast("Not Authorized: Error fetching branches")
            return
        }
        Http.get(`branch/${appName ? appName : soloFlowResp?.id ? soloFlowResp?.id : ""}`).subscribe((res: any) => {
            setBranches(res)
            res && res.forEach((e: any) => {
                if (e.branch_name === "main") {
                    getVersion(e.branch_id)
                }
            })
        },(err)=>{
            console.error(err)
            if(err==="Forbidden"){
                ErrorToast("Not Authorized: Error fetching branches")
            }
        })
    }

    const getVersion = (branch: any) => {
        Http.get(`versions/${appName ? appName : soloFlowResp?.id ? soloFlowResp?.id : ""}?branchId=${branch}`).subscribe((res: any) => {
            const versionCode: any = _.maxBy(res, 'version_code')
            const reindexs = _.findIndex(res, versionCode)
            res[reindexs]['currentVersion'] = true;
            const data = _.find(res, ['currentVersion', true])
            if (data) {
                soloFlows(data)
            }
        })
    }

    return (
        <Modal
            data-test-id="Solo_Modal"
            width={676}
            maskClosable={false}
            className={`${style.model} Bpmn_Create_Modal card-container`}
            title={<div className="modal-header-title"> Solo Flows </div>}
            onCancel={() => {
                setvisible(false);
            }}
            closeIcon={<Icon data-test-id="close" style={{ color: "white" }} type="close" />}
            destroyOnClose={true}
            footer={[
                <div key={"footer-1"}>
                    <Button
                        data-test-id="cancel"
                        type="link"
                        style={{ color: "#8797a8" }}
                        onClick={() => { setvisible(false) }}>
                        Cancel
                    </Button>
                    <Button
                        data-test-id="create"
                        //type="primary"
                        disabled={soloFlowName && appNameNotinList ? false : !selectedSoloFlow ? true : false}
                        className="modal-create-Button"
                        onClick={() => {
                            const findSoloFlow = soloFlow?.map((e: any) => {
                                if (e.name === selectedSoloFlow) {
                                    return {
                                        id: e.id,
                                        name: e.name
                                    }
                                }
                            }).filter((e: any) => { return e })
                            setSelectedSoloFlow("")
                            setAppName("")
                            setAppNotinList("")
                            setSoloFlowName("")
                            let openSoloFlow: any = soloFlowName && appNameNotinList ? false : true
                            getSoloFlows(soloFlow?.length > 0 ? findSoloFlow[0] : { name: soloFlowName }, appName ? appName : appNameNotinList ? appNameNotinList : "", "select", openSoloFlow);
                        }}
                    >
                        {soloFlowName && appNameNotinList ? "Save" : "Select"}
                    </Button>
                </div>,
            ]}
            visible={visible}
        >
            <div style={{ padding: 20 }}>
                <div style={{ marginBottom: 15 }}>
                    <div style={{ color: "#10002E", padding: 3 }}>Choose App</div>
                    <Select
                        placeholder="Select app or type appId"
                        style={{ width: "100%" }}
                        size="large"
                        value={findAppName ? findAppName : appNameNotinList ? appNameNotinList : undefined}
                        showSearch={true}
                        onSearch={(val: any) => {
                            setAppName("")
                            setFindAppname("")
                            if (val) {
                                setAppNotinList(val)
                                setSoloFlow([])
                                setSelectedSoloFlow("")
                            }
                        }}
                        onChange={(e: any) => {
                            setSelectedSoloFlowResp && setSelectedSoloFlowResp({})
                            setAppName(e);
                        }} >
                        {appList && appList.map((el: any) => {
                            return <Option value={el.appId} key={el.appId}>
                                {el.appName}
                            </Option>
                        })}
                    </Select>
                </div>
                {(soloFlow?.length > 0 || appNameNotinList) && <div style={{ marginBottom: 15 }}>
                    <div style={{ color: "#10002E", padding: 3 }}>Choose Solo Flow</div>
                    <Select
                        placeholder="Select flow or type flow name"
                        showSearch={true}
                        onSearch={(val: any) => {
                            setSelectedSoloFlow("")
                            if (val) {
                                setSoloFlowName(val)
                            }
                        }}
                        style={{ width: "100%" }}
                        size="large"
                        value={selectedSoloFlow ? selectedSoloFlow : soloFlowName ? soloFlowName : undefined}
                        onChange={(e: any) => {
                            setSelectedSoloFlow(e)
                            setSoloFlowName("")
                        }}>
                        {soloFlow?.map((el: any) => {
                            return <Option
                                value={el.name}
                                key={el.id}
                            >
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    {<img alt="publicIcon" style={{ height: "15px" }} src={el.type === "public" ? publicIcon : privateIcon} />}
                                    {<div style={{ fontSize: "15px", marginLeft: "4px", marginTop: "2px" }}>{el.name}</div>}
                                </div>
                            </Option>
                        })}
                    </Select>
                </div>}
                {soloFlow?.length === 0 && findAppName &&
                    <div style={{ color: "#cc3300", textAlign: "center", width: "100%" }}>No Solo Flows Found</div>
                }
            </div>
        </Modal >
    );
};
